import React from 'react';
import { Grid } from '@nextiva/next-ui-components';

import CompanyTaxId from './CompanyTaxId';

export const RenderCompanyTaxId = ({
  companyTaxId,
  payload,
  setPayload,
  setPristine,
}) => {
  if (companyTaxId?.data || companyTaxId?.error?.errorCode === 602) {
    return (
      <Grid item>
        <CompanyTaxId
          setPristine={setPristine}
          payload={payload}
          setPayload={setPayload}
        />
      </Grid>
    );
  }

  return null;
};
